import { useQuery } from "@tanstack/react-query";
import type { Matter } from "@/shared/cache";
import { useApi } from "@/shared/utils/request";

export function useFirmMatters() {
	const { makeApiRequest } = useApi();
	const query = useQuery({
		queryKey: ["admin-firm-matters"],
		queryFn: async ({ signal }) => {
			const response = await makeApiRequest({
				endpoint: "/matters",
				method: "GET",
				queryParams: { scope: "firm" },
				otherOptions: { signal },
			});
			if (response.status === "ERROR") {
				throw new Error(response.error || "Failed to load firm matters");
			}
			return (response.data ?? []) as Matter[];
		},
	});

	return {
		matters: query.data ?? [],
		loading: query.isLoading,
		error: query.error?.message ?? null,
	};
}
